<template>
  <div>
    <baidu-map class="map" :center="map.center" :zoom="map.zoom" @ready="handler">
      <!--缩放-->
      <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"/>
      <!--定位-->
      <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"/>
      <!--点-->
      <bmlMarkerClusterer :averageCenter="true">
        <bm-marker v-for="item of citys" :key="item.id" :position="item.center" animation="BMAP_ANIMATION_DROP" @click="lookDetail(item)">
        </bm-marker>
      </bmlMarkerClusterer>
      <!--提示信息-->
      <bm-info-window :show="pointDetail.show" :position="pointDetail.center" :title="'门店信息'">
        <p>经销商：{{ pointDetail.allName }}</p>
        <p>详细地址：{{ pointDetail.info }}</p>
      </bm-info-window>
    </baidu-map>
  </div>
</template>

<script>
import bmlMarkerClusterer from 'vue-baidu-map/components/extra/MarkerClusterer'
export default {
  props: {
    citys: {
      type: Array
    }
  },
  components: {
    bmlMarkerClusterer
  },
  data() {
    return {
      pointDetail: {
        show: false,
        info: '',
        allName: '',
        center: {}
      },
      map: {
        center: { lng: '116.4035', lat: '39.915' },
        zoom: 4
      }
    }
  },
  methods: {
    handler({ BMap, map }) {
      console.log(BMap, map)
      // 鼠标缩放
      map.enableScrollWheelZoom()// 启用滚轮放大缩小，默认禁用
      map.enableContinuousZoom()
    },
    lookDetail(item) {
      this.pointDetail.center = item.center
      this.pointDetail.show = true
      this.pointDetail.info = item.address
      this.pointDetail.allName = item.allName
    }
  }
}
</script>

<style scoped>
  .map {
    width: 100%;
    height: 400px;
  }
</style>
